import React from "react";

const PerformanceGraph = ({style = {}, size = "36", className = "", fill = "#73788B", stroke="73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M5.358 3v26.864h26.861v3.358H2V3h3.358Zm25.08 4.935L34 11.497 23.825 21.673l-5.037-5.038-6.613 6.615-3.561-3.562L18.788 9.512l5.037 5.038 6.614-6.615Z"
        />
    </svg>
);

export default PerformanceGraph;

